(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.bestseller-shades__quick-add');
    if (!button) return;

    event.preventDefault();

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.classList.contains('is-loading')) return;

    button.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }]
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function () {
        button.classList.remove('is-loading');
        button.classList.add('is-added');

        // Update the cart bubble/count if Dawn's cart icon bubble exists
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        var cartIconBubble = document.querySelector('.cart-count-bubble');
        if (cartIconBubble) {
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              cartIconBubble.textContent = cart.item_count;
            });
        }

        setTimeout(function () {
          button.classList.remove('is-added');
        }, 1800);
      })
      .catch(function () {
        button.classList.remove('is-loading');
        button.textContent = 'Try again';
      });
  });
})();
